import React from "react";
import "./styles/DashboardScreen.css";
import { useSelector } from "react-redux";
import BreadCrumbsContainer from "../../Common/Breadcrumbs";
import DashboardComponent from "./Components/DashboardComponent";

export default function DashboardScreen() {
  return (
    <div>
      <BreadCrumbsContainer />
      <DashboardComponent />
    </div>
  );
}
